import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_GEN_AI_DEMO_IEAM_5 = {
  title:
    "With the AI's results in hand, Tony finds\nhimself at the deployment screen, standing \nat the threshold of transforming his \nwarehouse operations.",
  subtitle: "ai ASSISTED demo",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_121"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_119"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_GEN_AI_Demo_01.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/IEAM/IEAM_GEN_AI_DEMO_05_BUBBLE.png",
          imageStyle: { alignSelf: "flex-end" },
        },
        {
          image: "ENG/IEAM/IEAM_GEN_AI_DEMO_05_TILE.png",
          imageStyle: {
            alignSelf: "flex-start",
            marginTop: "-48px",
            marginLeft: "56px",
          },
        },
      ]}
      pageNumber={"ENG_120"}
    />
  ),
};
